import {
  createFrontendModule,
  createTranslationMessages,
} from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { catalogTranslationRef } from '@backstage/plugin-catalog/alpha';

export const essityCatalogTranslationsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    TranslationBlueprint.make({
      name: 'catalog-overrides',
      params: {
        resource: createTranslationMessages({
          ref: catalogTranslationRef,
          messages: {
            'aboutCard.systemField.label': 'Application',
            'hasSystemsCard.title': 'Applications',
            'hasSystemsCard.emptyMessage': 'No applications found',
            'hasSubdomainsCard.title': 'Solutions',
            'hasSubdomainsCard.emptyMessage': 'No solutions found',
            'hasComponentsCard.title': 'Components',
            'hasResourcesCard.title': 'Resources',
          },
        }),
      },
    }),
  ],
});
